import React, { Component } from "react";
import "./timecodeinput.css";
import { getFacetedMinMaxValues } from "@tanstack/react-table";

class TimeCodeInput extends Component {
    constructor(props) {
        super(props);

        const digits = this.normalizeTimecode(props.initialValue);

        this.baseDigits = digits;
        this.typedDigits = "";


        this.IntervalCursor = null;
        this.state = {
            value: this.formatTimecode(digits),
            focused: false,
            valid: this.isValidTimecode(digits),
            cursoron: true,
        };
    }

    setValue(timecode)
    {
        const digits = this.normalizeTimecode(timecode);

        this.baseDigits = digits;
        this.typedDigits = "";
        this.setState = {
            value: this.formatTimecode(digits),
            valid: this.isValidTimecode(digits),
        }
    }

    startIntervalCursor() 
    {
      this.IntervalCursor = setInterval(() => {
        const newvalue = !this.state.cursoron;
        this.setState ({cursoron: newvalue});
      }, 500); 
    }
    
    stopIntervalCursor()
    {
      if (this.IntervalCursor) clearInterval(this.IntervalCursor);
      this.IntervalCursor = null;
    }


    componentDidMount() {
        //document.addEventListener("mousedown", this.handleDocumentMouseDown);
        this.startIntervalCursor();
        if (this.props.autoFocus && this.container) {
            this.container.focus();
        }        
        if (this.props.onChange) {
            this.props.onChange(this.formatTimecode(this.baseDigits), this.baseDigits, this.state.valid);
        }
    }

    componentWillUnmount() {
        //document.removeEventListener("mousedown", this.handleDocumentMouseDown);
        this.stopIntervalCursor();
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.initialValue !== this.props.initialValue 
        ) {
            const digits = this.normalizeTimecode(this.props.initialValue);

            this.baseDigits = digits;
            this.typedDigits = "";

            this.setState({
                value: this.formatTimecode(digits)
            });
            if (this.props.autoFocus) this.focus();

            if (this.props.onChange) {
                this.props.onChange(this.formatTimecode(this.baseDigits), this.baseDigits, this.state.valid);
            }

        }
    }

    normalizeTimecode = (value) => {
        if (!value) {
            return "00000000";
        }

        const digits = String(value).replace(/\D/g, "");

        return digits.padStart(8, "0").slice(-8);
    };

    formatTimecode = (digits) => {
        digits = digits.padStart(8, "0").slice(-8);

        return (
            digits.substring(0, 2) +
            ":" +
            digits.substring(2, 4) +
            ":" +
            digits.substring(4, 6) +
            ":" +
            digits.substring(6, 8)
        );
    };

    isValidTimecode = (digits) => {
        const hours = parseInt(digits.substring(0, 2), 10);
        const minutes = parseInt(digits.substring(2, 4), 10);
        const seconds = parseInt(digits.substring(4, 6), 10);
        const frames = parseInt(digits.substring(6, 8), 10);

        if (hours > 99)
            return false;

        if (minutes > 59)
            return false;

        if (seconds > 59)
            return false;

        if (frames > this.props.maxFrames)
            return false;

        return true;
    };

    getDigit = (event) => {
        /*
         * event.code est important pour AZERTY.
         *
         * Digit1 ... Digit9
         * Numpad1 ... Numpad9
         *
         * On utilise event.code en priorité afin que
         * Shift+& / Shift+é / etc. fonctionnent correctement.
         */

        if (event.code) {
            const match = event.code.match(/^(Digit|Numpad)([0-9])$/);

            if (match) {
                return match[2];
            }
        }

        /*
         * Sécurité pour les claviers où event.code
         * n'est pas disponible.
         */
        if (/^[0-9]$/.test(event.key)) {
            return event.key;
        }

        return null;
    };

    handleFocus = () => {
        /*
         * À chaque nouveau focus, on recommence une saisie
         * à partir de la valeur actuellement affichée.
         */
        this.baseDigits = this.normalizeTimecode(this.state.value);
        this.typedDigits = "";

        this.setState({
            focused: true,
            cursoron: true,
        });
    };

    handleBlur = () => {
    this.baseDigits = this.normalizeTimecode(this.state.value);
    this.typedDigits = "";

    this.setState({
        focused: false
    });
    };

    focus = () => {
    if (this.container) {
        this.container.focus();
    }
}   ;

    handleDocumentMouseDown = (event) => {
        if (
            this.container &&
            !this.container.contains(event.target)
        ) {
            this.setState({
                focused: false
            });

            this.baseDigits = this.normalizeTimecode(this.state.value);
            this.typedDigits = "";
        }
    };

handleKeyDown = (event) => {

    /*
     * Tant que le contrôle a le focus, on ne laisse
     * aucun keydown remonter vers les parents.
     */
    event.preventDefault();
    event.stopPropagation();

    /*
     * BACKSPACE
     */
    if (event.key === "Backspace") {
        this.handleBackspace();
        return;
    }

    /*
     * CHIFFRE
     */
    const digit = this.getDigit(event);

    if (digit !== null) {
        this.handleDigit(digit);
        return;
    }

    /*
     * Toutes les autres touches sont simplement
     * consommées.
     */
};

handleDigit = (digit) => {
    /*
     * Maximum 8 chiffres saisis.
     */
    if (this.typedDigits.length >= 8) {
        return;
    }

    /*
     * On ajoute le chiffre à droite.
     */
    const newTypedDigits = this.typedDigits + digit;

    const prefixLength = 8 - newTypedDigits.length;

    const candidate =
        this.baseDigits.substring(0, prefixLength) +
        newTypedDigits;

    /*
     * IMPORTANT :
     * On accepte TOUJOURS le chiffre, même si le
     * timecode est momentanément invalide.
     */
    this.typedDigits = newTypedDigits;

    this.updateValue(candidate);
};
    handleBackspace = () => {
        /*
         * S'il y a des chiffres saisis pendant cette session,
         * on retire simplement le dernier.
         */
        if (this.typedDigits.length > 0) {
            this.typedDigits =
                this.typedDigits.substring(
                    0,
                    this.typedDigits.length - 1
                );

            const prefixLength = 8 - this.typedDigits.length;

            const candidate =
                this.baseDigits.substring(0, prefixLength) +
                this.typedDigits;

            this.updateValue(candidate);

            return;
        }
        return;
        /*
         * Aucun chiffre saisi pendant cette session.
         *
         * On fait quand même un Backspace logique sur les
         * 6 derniers chiffres.
         *
         * 10:00:00:12
         *       ↓
         * 10:00:00:01
         */
        const digits = this.normalizeTimecode(this.state.value);

        const hours = digits.substring(0, 2);
        const tail = digits.substring(2);

        const newTail =
            "0" + tail.substring(0, 5);

        const candidate = hours + newTail;

        this.baseDigits = candidate;

        this.updateValue(candidate);
    };

        updateValue = (digits) => {
            const value = this.formatTimecode(digits);
            const valid = this.isValidTimecode(digits);

            this.setState({
                value,
                valid
            });

            if (this.props.onChange) {
                this.props.onChange(value, digits, valid);
            }
        };


    getValue()
    {
        return {timecode: this.state.value, error: !this.state.valid};
    }
    render() {
        const aspace = (<>&nbsp;</>);
        return (
            <div
                ref={(el) => {
                    this.container = el;
                }}
                className={
                    "timecode-input" +
                    (this.state.focused
                        ? " timecode-input-focused"
                        : "") +
                    (!this.state.valid
                        ? " timecode-input-invalid"
                        : "")
                }                
                tabIndex={0}
                onClick={() => {
                    if (this.container) {
                        this.container.focus();
                    }
                }}
                onFocus={this.handleFocus}
                onBlur = {this.handleBlur}
                onKeyDown={this.handleKeyDown}
            >
                {this.state.value}
                {this.state.focused && this.state.cursoron?"|":aspace}
            </div>
        );
    }
}



TimeCodeInput.defaultProps = {
    initialValue: "00:00:00:00",
    maxFrames: 29,
    onChange: null,
    autoFocus:false,
};

export default TimeCodeInput;